import React from 'react'
import './styles.css'

import CallToAction from '../../atoms/callToAction'
import Spacer from '../../atoms/Spacer'

export default function Cover() {
  const [isMobile, setIsMobile] = React.useState(false)

  React.useEffect(() => {
    if (window.innerWidth < 768) {
      setIsMobile(true)
    }
  }, [])

  return (
    <div className="container">
      <div className="text-section">
        <div className="cover-text">
          <div>
            <h2>Dra. Gabriela Pinheiro</h2>
            <h3>Pediatra em Belo Horizonte</h3>
          </div>
          <Spacer size={isMobile ? 10 : 40} />
          <div
            style={{
              justifySelf: 'flex-start',
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
            }}
          >
            <CallToAction>Agendar Consulta</CallToAction>
          </div>
        </div>
      </div>
    </div>
  )
}
